module.exports = "../fonts/HelveticaNeueLTW01-65Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-65Medium.ttf
// module id = St0U
// module chunks = 1